import { render } from "./shareView.vue?vue&type=template&id=a86c55e8&scoped=true&lang=true"
import script from "./shareView.vue?vue&type=script&lang=js"
export * from "./shareView.vue?vue&type=script&lang=js"

import "./shareView.vue?vue&type=style&index=0&id=a86c55e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a86c55e8"]])

export default __exports__